import styled from "styled-components";

export const Date = styled.span`
  font-size: 0.875rem;
  font-weight: normal;
`;
